export function getIcon(name: string) {
  const icon = require(`../icons/${name}.svg?raw`);

  return { __html: icon };
}
